The information of the position profile to be updated.
